import { Grid, TextField } from "@material-ui/core"
import React, { useState } from "react"

export default function UpdateSettingsSection(props) {
  const { setMessageData, setValidated } = props
  const [cycleTime, setCycleTime] = useState(0)
  const [triggerNumber, setTriggerNumber] = useState(0)

  const reviewComponent = (cycleValue, triggerValue) => {
    setCycleTime(cycleValue)
    setTriggerNumber(triggerValue)
    if (cycleValue && triggerValue) {
      setValidated(true)
      setMessageData({
        cycleTime: cycleValue,
        triggerNumber: triggerValue,
      })
    } else {
      setValidated(false)
      setMessageData(null)
    }
  }

  return (
    <>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          type="number"
          margin="dense"
          label="Cycle Time (minutes)"
          name="Cycle Time (minutes)"
          value={cycleTime}
          onChange={(event) =>
            reviewComponent(parseInt(event.currentTarget.value, 10), triggerNumber)
          }
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          type="number"
          margin="dense"
          label="Trigger Number"
          name="Trigger Number"
          value={triggerNumber}
          onChange={(event) => reviewComponent(cycleTime, parseInt(event.currentTarget.value, 10))}
        />
      </Grid>
    </>
  )
}
